import buildSdkParamsFromProperties from 'app/playbook-editor/buildSdkParamsFromProperties';

export default function transformSdkConnectionUpload(uploadedData, existingConnectionTemplate) {
  if (!existingConnectionTemplate?.properties) {
    return uploadedData;
  }

  const integrationKey = Object.keys(uploadedData).find(key => key !== 'version' && key !== 'params');
  if (!integrationKey) {
    return uploadedData;
  }

  const integrationData = uploadedData[integrationKey] ?? {};
  const uploadedParams = uploadedData.params ?? [];
  const mergedParams = (existingConnectionTemplate.params ?? []).map(param => {
    const uploaded = uploadedParams.find(p => p.name === param.name);
    return uploaded ? { ...param, ...uploaded } : param;
  });

  const transformedParams = buildSdkParamsFromProperties({
    properties: existingConnectionTemplate.properties,
    required: existingConnectionTemplate.required ?? [],
    existingParams: mergedParams,
    integrationData,
  });

  return {
    ...existingConnectionTemplate,
    params: transformedParams,
  };
}
